export default "__VITE_ASSET__CgtGUQEe__"